import * as moment from 'moment'

export class ProspectModel {
  id: number
  first_name: string
  last_name: string
  company_name: string
  email: string
  status: number
  created_at: any
  description: string
  iban: string

  constructor(data) {
    this.id = data.id ? data.id : null
    this.first_name = data.first_name ? data.first_name : null
    this.last_name = data.last_name ? data.last_name : null
    this.company_name = data.company_name ? data.company_name : null
    this.email = data.email ? data.email : null
    this.created_at = data.created_at ? moment(data.created_at) : null
    this.description = data.description ? data.description : null
    this.iban = data.iban ? data.iban : null
    this.status = data.status ? data.status : 1
  }

  mapStatus() {
    switch (this.description) {
      case 'Cancelled with subcode: 1001':
        return 'Niet bruikbaar rekening nummer'
      case 'Cancelled with subcode: 1002':
        return 'Aanvrager niet bevoegd op zakelijke rekening '
      case 'Cancelled with subcode: 1003':
        return 'Openen nieuw product niet toegestaan (KI<>groen)'
      case 'Cancelled with subcode: 1004':
        return 'Na overleg klant met LB afgebroken'
      case 'Cancelled with subcode: 1005':
        return 'Aanvraag afgewezen aanvrager niet bevoegd op zakelijke rekening'
      case 'Cancelled with subcode: 1006':
        return 'Aanvraag afgewezen klant niet gevonden (alleen mogelijk bij anoniem)'
      case 'Cancelled with subcode: 1007':
        return 'Klant heeft al Tellow'
      case 'Cancelled with subcode: 1008':
        return 'Er loopt al een aanvraag voor Tellow'
      default:
        return this.description
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/track/prospect.model.ts